var map = {
	"./camera-active.svg": 8889,
	"./code-active.svg": 6309,
	"./customize-active.svg": 1899,
	"./dropbox-active.svg": 3068,
	"./facebook-active.svg": 9347,
	"./gallery-active.svg": 960,
	"./globe-active.svg": 8746,
	"./google-active.svg": 5677,
	"./instagram-active.svg": 6973,
	"./laptop-active.svg": 4538,
	"./web-active.svg": 9490
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 305;